"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

require("./style.scss");
/**
* Image for a Card Component.
*/


var CardImage = function CardImage(props) {
  var alt = props.alt;
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement("div", {
    className: "story-card__image"
  }, react_1.default.createElement("img", __assign({}, props, {
    alt: alt
  })));
};

CardImage.propTypes = {
  /** Alt Text to describe the `CardImage` */
  alt: prop_types_1.default.string.isRequired,

  /** Determines if the `CardImage` can be click+dragged */
  draggable: prop_types_1.default.bool,

  /** Source to fill the `CardImage` */
  src: prop_types_1.default.string.isRequired
};
CardImage.defaultProps = {
  draggable: undefined
};
exports.default = CardImage;